module.exports = __webpack_public_path__ + "static/media/competitors_image1.f34d6774.webp";